import { ReduxStateHandler } from '../ReduxStateHandler';

export const UserSignupErrorStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_USER_SIGNUP_ERROR',
  statePath: 'userSignupError',
});

// Keeps track of where the user came from.
// Currently used to track users coming from the member ID reminder
export const UserSourceStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_USER_SOURCE',
  statePath: 'userSource',
});
